async function notify(path: string, message: string, data?: any): Promise<void> {
  const webhookUrl = process.env.TOWN_WEB_TEAMS_WEBHOOK_URL || ''; // 환경 변수에서 웹훅 URL 가져오기
  if (!webhookUrl) {
    console.error('웹훅 URL이 설정되어 있지 않습니다.');
    return;
  }

  const payload = {
    type: 'message',
    attachments: [
      {
        contentType: 'application/vnd.microsoft.card.adaptive',
        content: {
          $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
          type: 'AdaptiveCard',
          version: '1.3',
          body: [
            {
              type: 'TextBlock',
              size: 'Medium',
              weight: 'Bolder',
              text: '🚨 이실장 운영 에러 발생',
            },
            {
              type: 'ColumnSet',
              columns: [
                {
                  type: 'Column',
                  items: [
                    {
                      type: 'TextBlock',
                      weight: 'Bolder',
                      color: 'Attention',
                      text: '실패',
                      wrap: true,
                    },
                  ],
                  width: 'auto',
                },
              ],
            },
            {
              type: 'TextBlock',
              text: path,
              wrap: true,
            },
            {
              type: 'TextBlock',
              text: message,
              wrap: true,
            },
            // {
            //   type: 'TextBlock',
            //   text: data ? JSON.stringify(data) : '',
            //   wrap: true,
            // },
            // {
            //   '@type': 'MessageCard',
            //   '@context': 'http://schema.org/extensions',
            //   summary: '에러 알림',
            //   themeColor: '0076D7',
            //   sections: [
            //     {
            //       activityTitle: '🚨 이실장 운영 에러 발생',
            //       activitySubtitle: path,
            //       text: message,
            //     },
            //     {
            //       startGroup: true,
            //       title: '상세 정보 (클릭하여 확인)',
            //       potentialAction: [
            //         {
            //           '@type': 'ShowCardAction',
            //           name: '자세히 보기',
            //           card: {
            //             type: 'AdaptiveCard',
            //             body: [
            //               {
            //                 type: 'TextBlock',
            //                 text: data ? JSON.stringify(data, null, 2) : '상세 정보 없음',
            //                 wrap: true,
            //               },
            //             ],
            //           },
            //         },
            //       ],
            //     },
            //   ],
            // },
            // {
            //   type: 'FactSet',
            //   facts: data
            //     ? Object.keys(data).map((key) => ({
            //         title: key,
            //         value: data[key],
            //       }))
            //     : [],
            // },
            {
              type: 'Container',
              items: [
                {
                  type: 'FactSet',
                  facts: data
                    ? Object.keys(data).map((key) => ({
                        title: key,
                        value: data[key],
                      }))
                    : [],
                },
              ],
              style: 'emphasis',
              height: 'stretch',
              maxHeight: '300px',
            },
          ],
        },
      },
    ],
  };

  try {
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    console.log('response' + response);
    // const responseData = await response.json();
    // console.log('응답:', responseData);
  } catch (error) {
    console.error('알림 전송 실패:', error);
  }
}

export { notify };
